import { render, staticRenderFns } from "./processWork.vue?vue&type=template&id=635be582&scoped=true&"
import script from "./processWork.vue?vue&type=script&lang=js&"
export * from "./processWork.vue?vue&type=script&lang=js&"
import style0 from "./processWork.vue?vue&type=style&index=0&id=635be582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635be582",
  null
  
)

export default component.exports